import styled from 'styled-components';
import { palette } from 'styled-theme';

const Flex = styled.div`
  display: flex;
  flex-direction: ${({ direction = 'row' }) => direction};
  flex: ${({ flex = 'initial' }) => flex};
`;

export default Flex;
